import * as Types from '../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EditCriNotesMutationVariables = Types.Exact<{
  notes?: Types.InputMaybe<Types.Scalars['String']>;
  invoiceNumber: Types.Scalars['String'];
}>;


export type EditCriNotesMutation = { __typename?: 'MutationModel', customRollupInvoices?: { __typename?: 'CustomRollupInvoiceMutationModel', edit?: { __typename?: 'ValidationResponse', errors?: Array<{ __typename?: 'ValidationError', message: string, argumentName?: string | null } | null> | null } | null } | null };


export const EditCriNotesDocument = gql`
    mutation editCRINotes($notes: String, $invoiceNumber: String!) {
  customRollupInvoices {
    edit(notes: $notes, invoiceNumber: $invoiceNumber) {
      errors {
        message
        argumentName
      }
    }
  }
}
    `;
export type EditCriNotesMutationFn = Apollo.MutationFunction<EditCriNotesMutation, EditCriNotesMutationVariables>;

/**
 * __useEditCriNotesMutation__
 *
 * To run a mutation, you first call `useEditCriNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCriNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCriNotesMutation, { data, loading, error }] = useEditCriNotesMutation({
 *   variables: {
 *      notes: // value for 'notes'
 *      invoiceNumber: // value for 'invoiceNumber'
 *   },
 * });
 */
export function useEditCriNotesMutation(baseOptions?: Apollo.MutationHookOptions<EditCriNotesMutation, EditCriNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCriNotesMutation, EditCriNotesMutationVariables>(EditCriNotesDocument, options);
      }
export type EditCriNotesMutationHookResult = ReturnType<typeof useEditCriNotesMutation>;
export type EditCriNotesMutationResult = Apollo.MutationResult<EditCriNotesMutation>;
export type EditCriNotesMutationOptions = Apollo.BaseMutationOptions<EditCriNotesMutation, EditCriNotesMutationVariables>;